import React, { useEffect } from "react";

export const Serializer = {
  marks: {
    tick: (props: { children: any }) => (
      <span className="tick">{props.children}</span>
    )
  }
};
